module.exports = __webpack_public_path__ + "media/images/oxfam-802c7c77a2eb6a4ff640e2e58e7fa01e.png";